import { List } from "react-admin";
import { PageTitle } from "../../misc/PageTitle";
import { AccessDenied } from "../../misc/AccessDenied";
import { EmptyState } from "../../misc/EmptyState";
import { grants } from "../../backoffice.access_control";
import { useCurrentDrivingSchoolId } from "../../hooks/useCurrentDrivingSchoolId";
import { MultiSelectInput } from "../../inputs/MultiSelectInput";
import { InvoiceCustomersDatagrid } from "../../resources/invoiceCustomersResource";

const title = "Rechnungskunden";

export function DrivingSchoolInvoiceCustomers() {
  const drivingSchoolId = useCurrentDrivingSchoolId();

  if (!grants.has("viewDrivingSchoolInvoiceCustomers")) {
    return (
      <>
        <PageTitle>{title}</PageTitle>
        <AccessDenied />
      </>
    );
  }

  return (
    <>
      <PageTitle>{title}</PageTitle>
      <List
        resource="invoiceCustomers"
        title=" " // <-- prevent that the default list title is rendered
        filter={{ drivingSchoolId }}
        filters={[
          <MultiSelectInput
            key="status"
            label="Status"
            source="status"
            variant="text"
            withMode
            choices={[
              { id: "active", name: "Aktiv" },
              { id: "cancelled", name: "Abgebrochen" },
              { id: "inactive", name: "Inaktiv" },
              { id: "onHold", name: "Pausiert" },
              { id: "outstandingPayments", name: "Offene Zahlungen" },
              { id: "completed", name: "Fertig" },
            ]}
            alwaysOn
          />,
        ]}
        sort={/* initial sort order: */ { field: "id", order: "ASC" }}
        exporter={false}
        empty={<EmptyState noEntriesText="Keine Rechnungskunden vorhanden." />}
      >
        <InvoiceCustomersDatagrid hideAktivPrefix />
      </List>
    </>
  );
}
